<!--=============================
=            PROFILE            =
==============================-->

<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Profile</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <v-card class="pa-3 ma-3" color="primary">
          <v-row align="center" justify="center">
            <v-col class="text-center" cols="12">
              <v-avatar class="profile" color="grey" size="164" tile>
                <img src="../../assets/img/21.jpg" />
              </v-avatar>
              <h1 class="subtitle-1 white--text font-weight-bold mb-4">Allison Walkwess</h1>
              <h4 class="subtitle-2 white--text">Build your application today!</h4>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">User Profile</div>
          <div slot="card-body">
            <div class="card user-profile o-hidden mb-4">
              <div class="card-body">
                <v-tabs>
                  <v-tab href="#tab-1">Timeline</v-tab>
                  <v-tab href="#tab-2">About</v-tab>

                  <v-tab href="#tab-3">Photos</v-tab>

                  <v-tab-item value="tab-1">
                    <v-card>
                      <v-timeline :dense="$vuetify.breakpoint.smAndDown">
                        <v-timeline-item color="purple lighten-2" fill-dot right>
                          <v-card>
                            <v-card-title class="purple lighten-2">
                              <v-icon dark size="42" class="mr-4">mdi-magnify</v-icon>
                              <h2 class="display-1 white--text font-weight-light">Post in Favorite</h2>
                            </v-card-title>
                            <v-container>
                              <v-row>
                                <v-col cols="12" md="10">
                                  Lorem ipsum dolor sit amet, no nam oblique
                                  veritus. Commune scaevola imperdiet nec ut,
                                  sed euismod convenire principes at. Est et
                                  nobis iisque percipit.
                                </v-col>
                                <v-col class="hidden-sm-and-down text-right" md="2">
                                  <v-icon size="64">mdi-calendar-text</v-icon>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </v-timeline-item>

                        <v-timeline-item color="amber lighten-1" fill-dot left small>
                          <v-card>
                            <v-card-title class="amber lighten-1 justify-end">
                              <h2 class="display-1 mr-4 white--text font-weight-light">Events</h2>
                              <v-icon dark size="42">mdi-home-outline</v-icon>
                            </v-card-title>
                            <v-container>
                              <v-row>
                                <v-col cols="12" md="8">
                                  Lorem ipsum dolor sit amet, no nam oblique
                                  veritus. Commune scaevola imperdiet nec ut,
                                  sed euismod convenire principes at. Est et
                                  nobis iisque percipit.
                                </v-col>
                                <v-col cols="12" md="4">
                                  Lorem ipsum dolor sit amet, no nam oblique
                                  veritus.
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </v-timeline-item>

                        <v-timeline-item color="cyan lighten-1" fill-dot right>
                          <v-card>
                            <v-card-title class="cyan lighten-1">
                              <v-icon class="mr-4" dark size="42">mdi-email-outline</v-icon>
                              <h2 class="display-1 white--text font-weight-light">Videos</h2>
                            </v-card-title>
                            <v-container>
                              <v-row>
                                <v-col v-for="n in 3" :key="n" cols="12" md="4">
                                  Lorem ipsum dolor sit amet, no nam oblique
                                  veritus no nam oblique.
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </v-timeline-item>

                        <v-timeline-item color="red lighten-1" fill-dot left small>
                          <v-card>
                            <v-card-title class="red lighten-1 justify-end">
                              <h2 class="display-1 mr-4 white--text font-weight-light">Frieds</h2>
                              <v-icon dark size="42">mdi-account-multiple-outline</v-icon>
                            </v-card-title>
                            <v-container>
                              <v-row>
                                <v-col class="hidden-sm-and-down" md="2">
                                  <v-icon size="64">mdi-server-network</v-icon>
                                </v-col>
                                <v-col cols="12" md="10">
                                  Lorem ipsum dolor sit amet, no nam oblique
                                  veritus. Commune scaevola imperdiet nec ut,
                                  sed euismod convenire principes at. Est et
                                  nobis iisque percipit, an vim zril disputando
                                  voluptatibus.
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </v-timeline-item>

                        <v-timeline-item color="green lighten-1" fill-dot right>
                          <v-card>
                            <v-card-title class="green lighten-1">
                              <v-icon class="mr-4" dark size="42">mdi-phone-in-talk</v-icon>
                              <h2 class="display-1 white--text font-weight-light">Call me</h2>
                            </v-card-title>
                            <v-container>
                              <v-row>
                                <v-col>
                                  Lorem ipsum dolor sit amet, no nam oblique
                                  veritus. Commune scaevola imperdiet nec ut,
                                  sed euismod convenire principes at. Est et
                                  nobis iisque percipit, an vim zril disputando
                                  voluptatibus, vix an salutandi sententiae.
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card>
                        </v-timeline-item>
                      </v-timeline>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item value="tab-2">
                    <v-card>
                      <h4>Personal Information</h4>
                      <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Eveniet, commodi quam! Provident quis voluptate
                        asperiores ullam, quidem odio pariatur. Lorem ipsum,
                        dolor sit amet consectetur adipisicing elit. Voluptatem,
                        nulla eos? Cum non ex voluptate corporis id asperiores
                        doloribus dignissimos blanditiis iusto qui repellendus
                        deleniti aliquam, vel quae eligendi explicabo.
                      </p>
                      <hr />
                      <v-form>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field v-model="first" label="First Name" outlined></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                              <v-text-field v-model="last" label="Last Name" outlined></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <v-text-field v-model="first" label="Age" outlined></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                              <v-text-field v-model="last" label="Relationship" outlined></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item value="tab-3">
                    <v-card>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="card text-white o-hidden mb-3">
                            <img class="card-img" src="../../assets/img/users/user-1.jpg" alt />
                            <div class="card-img-overlay">
                              <div class="p-1 text-left card-footer font-weight-light d-flex">
                                <span class="mr-3 d-flex align-items-center">
                                  <i class="material-icons">lock_open</i>
                                  12
                                </span>
                                <span class="d-flex align-items-center">
                                  <i class="material-icons">folder_special</i>03.12.2018
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-4">
                          <div class="card text-white o-hidden mb-3">
                            <img class="card-img" src="../../assets/img/users/user-2.jpg" alt />
                            <div class="card-img-overlay">
                              <div class="p-1 text-left card-footer font-weight-light d-flex">
                                <span class="mr-3 d-flex align-items-center">
                                  <i class="material-icons">lock_open</i>
                                  12
                                </span>
                                <span class="d-flex align-items-center">
                                  <i class="material-icons">folder_special</i>03.12.2018
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-4">
                          <div class="card text-white o-hidden mb-3">
                            <img class="card-img" src="../../assets/img/users/user-3.jpg" alt />
                            <div class="card-img-overlay">
                              <div class="p-1 text-left card-footer font-weight-light d-flex">
                                <span class="mr-3 d-flex align-items-center">
                                  <i class="material-icons">lock_open</i>
                                  12
                                </span>
                                <span class="d-flex align-items-center">
                                  <i class="material-icons">folder_special</i>03.12.2018
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="card text-white o-hidden mb-3">
                            <img class="card-img" src="../../assets/img/users/user-6.jpg" alt />
                            <div class="card-img-overlay">
                              <div class="p-1 text-left card-footer font-weight-light d-flex">
                                <span class="mr-3 d-flex align-items-center">
                                  <i class="material-icons">lock_open</i>
                                  12
                                </span>
                                <span class="d-flex align-items-center">
                                  <i class="material-icons">folder_special</i>03.12.2018
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="card text-white o-hidden mb-3">
                            <img class="card-img" src="../../assets/img/users/user-5.jpg" alt />
                            <div class="card-img-overlay">
                              <div class="p-1 text-left card-footer font-weight-light d-flex">
                                <span class="mr-3 d-flex align-items-center">
                                  <i class="material-icons">mms</i>
                                  12
                                </span>
                                <span class="d-flex align-items-center">
                                  <i class="material-icons">folder_special</i>03.12.2018
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="card text-white o-hidden mb-3">
                            <img class="card-img" src="../../assets/img/users/user-7.jpg" alt />
                            <div class="card-img-overlay">
                              <div class="p-1 text-left card-footer font-weight-light d-flex">
                                <span class="mr-3 d-flex align-items-center">
                                  <i class="material-icons">folder_special</i>
                                  12
                                </span>
                                <span class="d-flex align-items-center">
                                  <i class="material-icons">folder_special</i>03.12.2018
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-tab-item>
                </v-tabs>
              </div>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
import ListLove from "../../components/Widgets/List/ListLove.vue";
export default {
  components: {
    BaseCard,
    BaseHeader,
    ListLove
  }
};
</script>
<style scoped>
.profiletimeline {
  border-left: 1px solid rgba(120, 130, 140, 0.13);
  margin-left: 30px;
  margin-right: 10px;
  padding-left: 40px;
  position: relative;
}

.profiletimeline .sl-left {
  float: left;
  margin-left: -60px;
  margin-right: 15px;
  z-index: 1;
}

.profiletimeline .sl-left img {
  max-width: 40px;
}

.profiletimeline .sl-item {
  margin-bottom: 30px;
  margin-top: 8px;
}

.profiletimeline .sl-date {
  color: #99abb4;
  font-size: 12px;
}

.profiletimeline .time-item {
  border-color: rgba(120, 130, 140, 0.13);
  padding-bottom: 1px;
  position: relative;
}

.profiletimeline .time-item::before {
  content: " ";
  display: table;
}

.profiletimeline .time-item::after {
  background-color: #ffffff;
  border-color: rgba(120, 130, 140, 0.13);
  border-radius: 10px;
  border-style: solid;
  border-width: 2px;
  bottom: 0;
  content: "";
  height: 14px;
  left: 0;
  margin-left: -8px;
  position: absolute;
  top: 5px;
  width: 14px;
}

.profiletimeline .time-item-item::after {
  content: " ";
  display: table;
}

.profiletimeline .item-info {
  margin-bottom: 15px;
  margin-left: 15px;
}

.profiletimeline .item-info p {
  margin-bottom: 10px !important;
}

.customtab li a.nav-link,
.profile-tab li a.nav-link {
  border: 0 none;
  color: #455a64;
  padding: 15px 20px;
}

.customtab li a.nav-link.active,
.profile-tab li a.nav-link.active {
  border-bottom: 2px solid #1976d2;
  color: #1976d2;
}

.card-two {
  position: relative;
  margin: 0 !important;
  border: 0;
}

.card-two header {
  position: relative;
  width: 100%;
  height: 60px;
}

.card-two header .avatar {
  position: absolute;
  left: 50%;
  top: 30px;
  margin-left: -50px;
  z-index: 5;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  background: #ccc;
  border: 3px solid #fff;
}

.card-two header .avatar img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 100px;
  height: auto;
}

.card-two h3 {
  position: relative;
  margin: 80px 0 30px;
  text-align: center;
}

.card-two h3::after {
  content: "";
  position: absolute;
  bottom: -15px;
  left: 50%;
  margin-left: -15px;
  width: 30px;
  height: 1px;
  background: #000;
}

.card-two .desc {
  padding: 0 1rem 2rem;
  text-align: center;
  line-height: 1.5;
  color: #777;
}

.card-two .contacts {
  width: 200px;
  max-width: 100%;
  margin: 0 auto 3.5rem;
}

.card-two .contacts a {
  display: block;
  width: 33.333333%;
  float: left;
  text-align: center;
  color: #1976d2;
}

.card-two .contacts a:hover {
  color: #333;
}

.card-two .contacts a:hover .fa::before {
  color: #fff;
}

.card-two .contacts a:hover .fa::after {
  top: 0;
}

.card-two .contacts a .fa {
  position: relative;
  width: 40px;
  height: 40px;
  line-height: 39px;
  overflow: hidden;
  text-align: center;
  border: 2px solid #1976d2;
  border-radius: 50%;
}

.card-two .contacts a .fa:before {
  position: relative;
  z-index: 1;
}

.card-two .contacts a .fa::after {
  content: "";
  position: absolute;
  top: -50px;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-transition: top 0.3s;
  transition: top 0.3s;
  background: #1976d2;
}

.card-two .contacts a:last-of-type .fa {
  line-height: 36px;
}

.profile-widget-one .profile-one-bg {
  position: relative;
}

.profile-widget-one .profile-one-user-photo {
  position: relative;
}

.profile-widget-one .profile-one-user-photo .bg-overlay {
  background: rgba(0, 0, 0, 0.6);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.profile-widget-one .profile-one-user-photo .user-photo {
  bottom: 0;
  height: 100%;
  position: absolute;
  text-align: center;
  top: 0;
  width: 100%;
}

.profile-widget-one .profile-one-user-photo .user-photo img {
  border-radius: 100px;
  height: 100px;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  width: 100px;
}

.profile-widget-one .profile-one-user-content ul li {
  background: #ffffff;
  border-right: 1px solid #e7e7e7;
  border-bottom: 1px solid #e7e7e7;
  display: block;
  float: left;
  padding: 10px 0;
  text-align: center;
  width: 32%;
}

.profile-widget-one .profile-one-user-content ul li:last-child {
  border-right: 0px;
}

.profile-widget-one .profile-one-user-content h4 {
  line-height: 30px;
  font-size: 14px;
  margin: 0px;
}

.profile-widget-one .profile-one-user-content .earning-amount,
.profile-widget-one .profile-one-user-content .sold-amount {
  color: #26dad2;
  font-size: 24px;
  font-weight: 400;
  margin-top: 10px;
}

.profile-widget-one .profile-one-user-content .sold-amount {
  color: #4680ff;
  font-size: 24px;
  font-weight: 400;
  margin-top: 10px;
}

.profile-widget-one .profile-one-user-button {
  text-align: center;
  padding: 26px 0px;
}

.profile-widget-one .profile-btn-one {
  font-size: 18px;
  text-transform: uppercase;
  padding: 8px 15px;
  font-weight: 400;
  color: #4680ff;
}
.profile img {
  border-radius: 50%;
}
</style>

<!--====  End of PROFILE  ====-->
